var _module_exports = "<div class=\"threats-landscape lightbox-content modal-xxlarge-width\">\n    <div class=\"main-loader\"></div>\n    <div class=\"content\" data-jquery-scrollbar>\n        <iframe src=\"{{iframeUrl}}\" id=\"threats-landscape-iframe\"></iframe>\n    </div>\n</div>";
var path = 'scripts/controllers/modals/threats-landscape/threats-landscape.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Desktop-GUI-Build-Archive/oegui2/node_modules/ngtemplate-loader?relativeTo=/app/!./scripts/controllers/modals/threats-landscape/threats-landscape.html
// module id = tBMr
// module chunks = 0